import { render, staticRenderFns } from "./CusMyDoc.vue?vue&type=template&id=dbb49a0c&scoped=true&"
import script from "./CusMyDoc.vue?vue&type=script&lang=js&"
export * from "./CusMyDoc.vue?vue&type=script&lang=js&"
import style0 from "./CusMyDoc.vue?vue&type=style&index=0&id=dbb49a0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb49a0c",
  null
  
)

export default component.exports